import { useAuth } from 'Data/Auth.js';
import View from './view.js';
import React from 'react';

export default function Logic() {
  let auth = useAuth();
  return <View {...auth.permissions} signOut={auth.signOut} />;
}
